import { render, staticRenderFns } from "./DetailButton.vue?vue&type=template&id=435f7fb7&scoped=true"
import script from "./DetailButton.vue?vue&type=script&lang=js"
export * from "./DetailButton.vue?vue&type=script&lang=js"
import style0 from "./DetailButton.vue?vue&type=style&index=0&id=435f7fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f7fb7",
  null
  
)

export default component.exports